import React, {ChangeEventHandler, FocusEventHandler, useCallback, useEffect, useRef, useState} from 'react'
import {CFComponentProps} from 'module/CustomField/type/CFComponentType'
import {CFAttrKey} from 'module/CustomField/constant/CFAttrConstants'
import {CF} from 'module/CustomField/util/CustomField'
import {log} from 'common/log'
import {getSisDurationAsISO, getSisDurationBetween24H, parseSisTime} from 'util/SisDateTime'
import {SisType} from 'generated/JavaTO'
import {stripHTML} from 'util/StringUtil'
import {cssCFInput} from 'module/CustomField/style/cssCFInput'
import {useCFAttrTextAlignCSS} from 'module/CustomField/style/CFAlignmentStyle'

function toDuration(timeFrom: number, endTime: string) {
	const from = parseSisTime(timeFrom, {ignoreSeconds: true})
	const to = parseSisTime(endTime, {userInput: true, ignoreSeconds: true})
	return getSisDurationAsISO(getSisDurationBetween24H(from, to))
}


export function CustomFieldDurationAsTimeToComponent(props: CFComponentProps<string>) {
	let {model, modelValue, cfDef, setCb, disabled, placeholderHTML} = props
	if (!modelValue) modelValue = ''
	const ref = useRef<HTMLInputElement>(null)
	const attrFrom = CF.getCFAttr(cfDef, CFAttrKey.TimeFromAttr)?.value
	const [viewValue, setViewValue] = useState(modelValue)
	useEffect(() => {
		setViewValue(modelValue)
		const to = setTimeout(() => {
			if (window.document.activeElement === ref.current) ref.current?.select()
		}, 20)
		return () => clearTimeout(to)
	}, [modelValue, ref])

	const onChange = useCallback<ChangeEventHandler<HTMLInputElement>>(evt => setViewValue(evt.target.value), [])
	const onFocus = useCallback<FocusEventHandler<HTMLInputElement>>((evt) => evt.target.select(), [])
	const onBlur = useCallback(() => {
		setViewValue(modelValue) /* when no change happened, this value is kept in input. Otherwise the set call initiates the useEffect */
		setCb(toDuration(model[attrFrom as string], viewValue))
	}, [setCb, modelValue, model, attrFrom, viewValue])
	const cssAlign = useCFAttrTextAlignCSS(cfDef)

	if (!attrFrom) {
		log.error('Missing CFAttrKey: TimeFromAttr')
		return <div>ERROR: missing TimeFromAttr</div>
	} else if (cfDef.type !== SisType.Duration) {
		log.error('wrong cfDef.type (H required)', cfDef)
		return <div>ERROR: wrong type</div>
	} else {
		return <div>
			<input
				ref={ref}
				disabled={disabled}
				css={[cssCFInput, cssAlign]}
				placeholder={stripHTML(placeholderHTML)}
				value={viewValue}
				onChange={onChange}
				onFocus={onFocus}
				onBlur={onBlur}
			/>
		</div>
	}
}